import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../core/http/api.service';
import { UtilsService } from '../../core/services/utils/utils.service';

@Component({
  selector: 'app-twitter-session',
  templateUrl: './twitter-session.component.html',
  styleUrls: ['./twitter-session.component.css'],
  standalone: false,
})
export class TwitterSessionComponent implements OnInit {
  loading = true;
  submitting = false;
  session: any = {
    configured: false,
    status: 'empty',
    hasStoredProxy: false,
  };
  credentials = {
    username: '',
    email: '',
    password: '',
    proxy: '',
    totpSecret: '',
  };

  oauthLoading = true;
  oauthSubmitting = false;
  oauthStatus: any = { configured: false };
  refreshTokenInput = '';
  showRefreshTokenModal = false;

  postsLoading = true;
  posts: any[] = [];
  postsPage = 1;
  postsPerPage = 10;
  postsTotal = 0;
  postsStatusFilter = '';

  constructor(private api: ApiService, private utils: UtilsService) {}

  ngOnInit(): void {
    this.loadStatus();
    this.loadOauthStatus();
    this.loadPosts();
  }

  loadStatus(): void {
    this.loading = true;
    this.api.getTwitterPostingSession().subscribe(
      (res) => {
        this.session = res?.data || this.session;
        this.loading = false;
      },
      (err) => {
        this.loading = false;
        this.utils.resErr(err);
      },
    );
  }

  saveSession(): void {
    if (this.submitting) return;
    this.submitting = true;

    this.api.loginTwitterPostingSession(this.credentials).subscribe(
      (res) => {
        this.session = res?.data || this.session;
        this.credentials = {
          username: '',
          email: '',
          password: '',
          proxy: '',
          totpSecret: '',
        };
        this.submitting = false;
        this.utils.toastSuccess('Twitter posting session saved');
      },
      (err) => {
        this.credentials.password = '';
        this.credentials.totpSecret = '';
        this.submitting = false;
        this.loadStatus();
        this.utils.resErr(err);
      },
    );
  }

  loadOauthStatus(): void {
    this.oauthLoading = true;
    this.api.getTwitterOauthStatus().subscribe(
      (res) => {
        this.oauthStatus = res?.data || this.oauthStatus;
        this.oauthLoading = false;
      },
      (err) => {
        this.oauthLoading = false;
        this.utils.resErr(err);
      },
    );
  }

  saveRefreshToken(): void {
    if (this.oauthSubmitting || !this.refreshTokenInput) return;
    this.oauthSubmitting = true;

    this.api
      .setTwitterOauthRefreshToken({ refreshToken: this.refreshTokenInput })
      .subscribe(
        (res) => {
          this.oauthStatus = res?.data || this.oauthStatus;
          this.refreshTokenInput = '';
          this.oauthSubmitting = false;
          this.showRefreshTokenModal = false;
          this.utils.toastSuccess('Refresh token saved');
        },
        (err) => {
          this.oauthSubmitting = false;
          this.utils.resErr(err);
        },
      );
  }

  loadPosts(page: number = 1): void {
    this.postsLoading = true;
    this.postsPage = page;

    const query: any = { page, limit: this.postsPerPage };
    if (this.postsStatusFilter) query.status = this.postsStatusFilter;

    this.api.getTweetPostLogs(query).subscribe(
      (res) => {
        this.posts = res?.data || [];
        this.postsTotal = res?.total || 0;
        this.postsLoading = false;
      },
      (err) => {
        this.postsLoading = false;
        this.utils.resErr(err);
      },
    );
  }
}
